import { useEffect, useState, useRef } from "react";
import { useFindInventory } from "../../../hooks/useInventory";

export default function FindItem({ setSearch }) {
  const find = useFindInventory();
  const inputRef = useRef(null);
  const [inventoryId, setInventoryId] = useState();

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const doSearch = () => {
    find.mutate(parseInt(inventoryId));
    setSearch(null);
  }

  return <div className="field has-addons mt-2">
    <div className="control is-expanded">
      <input
        type="number"
        className="input"
        name="search"
        value={inventoryId}
        ref={inputRef}
        onChange={e => setInventoryId(e.target.value)}
      />
    </div>
    <div className="control">
      <a className="button is-info" onClick={doSearch}>
        Add
      </a>
    </div>
  </div>
}
